import { ReactComponent as Icon } from './removeIcon.svg'
import { theme } from '@ss/meta-core-components'
import React from 'react'
import { config } from '../../../config'

interface Props {
  ariaLabel?: string
  role?: string
}

export const RemoveIcon: React.FC<Props> = ({
  ariaLabel = 'remove',
  role = 'icon',
}) => {
  return (
    <Icon
      aria-label={ariaLabel}
      role={role}
      data-cy={'remove-icon'}
      fill={
        theme.type === 'dark' ? config.iconColorDark : config.iconColorLight
      }
    />
  )
}
